import actionTypes from "consts/actionTypes.js";

const initialState = {
  loading: false,
  success: undefined,
  error: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_RESETCODE_PENDING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_RESETCODE_SUCCESS:
      if (action.payload.error) {
        return {
          loading: false,
          error: action.payload,
        };
      }
      return {
        loading: false,
        success: true,
      };
    case actionTypes.GET_RESETCODE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reset.js